import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSourceTrackingPlan = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "gray",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M17.3828 8.75C16.8359 5.625 14.375 3.16406 11.25 2.61719V5C11.25 5.70312 10.6641 6.25 10 6.25C9.29688 6.25 8.75 5.70312 8.75 5V2.61719C5.58594 3.16406 3.125 5.625 2.57812 8.75H5C5.66406 8.75 6.25 9.33594 6.25 10C6.25 10.7031 5.66406 11.25 5 11.25H2.57812C3.125 14.4141 5.58594 16.875 8.75 17.4219V15C8.75 14.3359 9.29688 13.75 10 13.75C10.6641 13.75 11.25 14.3359 11.25 15V17.4219C14.375 16.875 16.8359 14.4141 17.3828 11.25H15C14.2969 11.25 13.75 10.7031 13.75 10C13.75 9.33594 14.2969 8.75 15 8.75H17.3828ZM0 10C0 4.49219 4.45312 0 10 0C15.5078 0 20 4.49219 20 10C20 15.5469 15.5078 20 10 20C4.45312 20 0 15.5469 0 10Z" })
});
export { SvgSourceTrackingPlan as ReactComponent };
